import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  Alert,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import cogoToast from 'cogo-toast';
import { connect } from "react-redux"
import Select from "react-select"
import moment from 'moment';

const NewContract = props => {

  const history = useHistory();


  const [assettypes, setAssettypes] = useState([]);
  const [assets, setAssets] = useState([]);
  const [vendors, setVendors] = useState([]);

  const [showDropdown, setShowDropdown] = useState(false);

  const [assettype, setAssettype] = useState(null);
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [contractType, setContractType] = useState(null);
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().add(1, 'year').format('YYYY-MM-DD'));
  const [vendor, setVendor] = useState(null);
  const [remarks, setRemarks] = useState('');

  const [reason, setReason] = useState('');

  const contractTypes = [
    {label: 'NCAMC', value: 'NCAMC'},
    {label: 'Inhouse', value: 'Inhouse'},
    {label: 'CAMC', value: 'CAMC'},
    {label: 'AMC', value: 'AMC'},
    {label: 'CMC', value: 'CMC'},
  ];

  const calcEndDate = (val) => {
    setEndDate(moment().add(val, 'months').format('YYYY-MM-DD'));
  };


  const [errors, setErrors] = useState([]);
  
  const [loading, setLoading] = useState(false);
  const [initializing, setInitializing] = useState(true);

  const fetchData = (id) => {
    setLoading(true);
      console.log('Fetching ', id);
      get(url.GET_CONTRACT+'/'+id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        // setAssettype({label: response.data.assettype.name, value: response.data.assettype.id});
        setSelectedAssets(response.data.assets.map(a => ({label: a.name, value: a.id})));
        setContractType({label: response.data.contract_type, value: response.data.contract_type});
        setStartDate(response.data.start_date);
        setEndDate(response.data.end_date);
        setVendor(response.data.vendor ? {label: response.data.vendor.name, value: response.data.vendor.id} : null);
        setRemarks(response.data.remarks);
        setLoading(false);
      }
      else {
        cogoToast.error('Could not fetch contract data');
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };


  const init = () => {
    setInitializing(true);
      get(url.GET_NEW_CONTRACT+'/'+props.filterBlock.id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setAssets(response.data.assets);
        setAssettypes(response.data.assettypes);
        setVendors(response.data.vendors);
        setInitializing(false);
      }
      else {
        cogoToast.error('Could not fetch data');
        setInitializing(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });

  }


  const handleSubmit = () => {
    
    if(!selectedAssets || selectedAssets.length < 1) {
      cogoToast.error('Please select at least one asset');
      return;
    }
    if(contractType == null) {
      cogoToast.error('Contract type is required');
      return;
    }
    if(endDate <= startDate) {
      cogoToast.error('End date cannot be before start date');
      return;
    }
    if(vendor == null) {
      cogoToast.error('Vendor is required');
      return;
    }
    if(vendor == null) {
      cogoToast.error('Vendor is required');
      return;
    }

    if(props.match.params.id && reason.trim() == '') {
      cogoToast.error('Please add a reason for editing');
      return;
    }

    let data = {
      id: props.match.params.id ? props.match.params.id : 'new',
      assets: selectedAssets.map(s => s.value),
      contract_type: contractType.value,
      start_date: startDate,
      end_date: endDate,
      vendor_id: vendor.value,
      // assettype_id: assettype.value,
      remarks: remarks,
      block_id: props.filterBlock.id,
      reason: reason,
    };

    console.log('data', data);

    setLoading(true);
    setErrors([]);
    post(url.POST_NEW_CONTRACT, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        history.push('/contracts/index');
        cogoToast.success('Contract '+ (props.match.params.id ? (props.match.params.id == 'new' ? 'added' : 'updated') : 'added') + ' successfully');
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });

  };


  React.useEffect(()=>{
    if(props.filterBlock) {
      setAssettype(null);
      setSelectedAssets(null);
      setVendor(null);
      init();
    }
  }, [props.filterBlock]);

  React.useEffect(()=>{
    if(props.match.params.id && props.match.params.id !== 'new') {
      fetchData(props.match.params.id);
    }
  }, []);



  // console.log('params:', props.match.params);

  // const displayedBlocks = blocks.length < 1 ? [] : blocks.filter(b => property == null ? false : b.property_id == property.value);

  const displayedAssets = assettype ? assets.filter(a => a.assettype_id == assettype.value) : assets.slice(0, 100);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.match.params.id ? (props.match.params.id == 'new' ? 'Add New' : 'Edit') : 'Add New'} Contract | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">{props.match.params.id ? (props.match.params.id == 'new' ? 'New' : 'Edit') : 'New'} contract</h3>
            <Link className="btn btn-secondary" to="/contracts/index">Back</Link>
          </div>


          {errors.length > 0 &&
          <div className="mt-3 mb-5">
            {errors.map((error, errorIdx)=>(
              <Alert key={errorIdx} color="danger">
                <i className="mdi mdi-alert-circle-outline me-2"></i>{error}
              </Alert>
            ))}
          </div>
          }

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row mt-2">
                <div className="col">
                  <div className="mb-4 row">
                    <label htmlFor="selectAssettype" className="col-sm-3 col-form-label fw-normal fst-italic">
                      Filter by Asset type..
                    </label>
                    <div className="col-sm-9">
                      <Select
                        classNamePrefix="select2-selection"
                        className="selectAssettype"
                        placeholder="Search..."
                        title="Asset type"
                        options={assettypes}
                        value={assettype}
                        isClearable
                        onChange={e => { 
                          // setSelectedAssets(null);
                          setAssettype(e); 
                        }}
                        />
                    </div>
                  </div>
                  <div className="mb-5 row">
                    <label htmlFor="selectAsset" className="col-sm-3 col-form-label label-required">Asset</label>
                    <div className="col-sm-9">
                        <Select
                            classNamePrefix="select2-selection"
                            id="selectAsset"
                            placeholder="Select..."
                            title="Asset"
                            options={displayedAssets}
                            value={selectedAssets}
                            closeMenuOnSelect={false}
                            isMulti
                            noOptionsMessage={() => "No assets found"}
                            onChange={e => { 
                              setSelectedAssets(e); 
                            }}
                            />
                    </div>
                  </div>
                  <div className="mt-3 mb-4 row">
                    <label htmlFor="selectContractType" className="col-sm-3 col-form-label label-required">Contract Type</label>
                    <div className="col-sm-9">
                      <Select
                        classNamePrefix="select2-selection"
                        id="selectContractType"
                        placeholder="Select one"
                        title="Contract type"
                        options={contractTypes}
                        value={contractType}
                        onChange={e => { 
                          setContractType(e); 
                        }}
                        />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="inputStartDate" className="col-sm-3 col-form-label label-required">Start Date</label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" id="inputStartDate"
                          type="date"
                          value={startDate} 
                          onChange={e => { 
                            setStartDate(e.target.value);
                          }}
                        />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="inputEndDate" className="col-sm-3 col-form-label label-required">End Date</label>
                    <div className="col-sm-7">
                      <input type="text" className="form-control" id="inputEndDate"
                          type="date"
                          value={endDate} 
                          onChange={e => { 
                            setEndDate(e.target.value);
                          }}
                        />
                    </div>
                    <div className="col-sm-2">
                      <Dropdown
                        isOpen={showDropdown}
                        toggle={() => { setShowDropdown(!showDropdown); }}
                      >
                        <DropdownToggle
                          tag="button"
                          className="btn btn-primary"
                        >
                          Set to <i className="mdi mdi-chevron-down"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem onClick={() => { calcEndDate(1); }}>1 Month</DropdownItem>
                          <DropdownItem onClick={() => { calcEndDate(3); }}>3 Months</DropdownItem>
                          <DropdownItem onClick={() => { calcEndDate(6); }}>6 Months</DropdownItem>
                          <DropdownItem onClick={() => { calcEndDate(9); }}>9 Months</DropdownItem>
                          <DropdownItem onClick={() => { calcEndDate(12); }}>1 Year</DropdownItem>
                          <DropdownItem onClick={() => { calcEndDate(24); }}>2 Years</DropdownItem>
                          <DropdownItem onClick={() => { calcEndDate(36); }}>3 Years</DropdownItem>
                          <DropdownItem onClick={() => { calcEndDate(60); }}>5 Years</DropdownItem>
                          <DropdownItem onClick={() => { calcEndDate(120); }}>10 Years</DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="selectVendor" className="col-sm-3 col-form-label label-required">Vendor</label>
                    <div className="col-sm-9">
                      <Select
                        classNamePrefix="select2-selection"
                        id="selectVendor"
                        placeholder="Select one..."
                        title="Vendor"
                        options={vendors}
                        value={vendor}
                        isClearable
                        onChange={e => { 
                          setVendor(e); 
                        }}
                        />
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label htmlFor="inputRemarks" className="col-sm-3 col-form-label">Remarks</label>
                    <div className="col-sm-9">
                      <textarea id="inputRemarks" rows={3} className="form-control" value={remarks} onChange={e=>{ setRemarks(e.target.value); }} />
                    </div>
                  </div>


                  { props.match.params.id &&
                  <div className="mt-5 mb-4 row">
                    <label htmlFor="inputReason" className="col-sm-3 col-form-label label-required">Reason for edit</label>
                    <div className="col-sm-9">
                      <textarea id="inputReason" rows={3} className="form-control" value={reason} onChange={e=>{ setReason(e.target.value); }} />
                    </div>
                  </div>
                  }

                </div>
              </div>
            </CardBody>
          </Card>


     </Container>

    <div className="mb-4 container">
      <div className="d-flex justify-content-center">
        <button type="button" className="btn btn-primary me-2" onClick={()=>{ handleSubmit(); }}>Submit</button>
        <Link className="btn btn-light" to="/contracts/index">Cancel</Link>
      </div>
    </div>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(NewContract)